import { DataParent, diffOptions } from "../models";
import moment from 'moment';
export function getChoicesDuplicatedIds(str: string): { [key: string]: number[] } {
    /* input "{0=Error, 1=Normal, 600=Normal, 4=Stop, 7=Stop}"*/
    /* output {Normal: [1, 600], Stop: [4, 7]} */


    const result: { [key: string]: number[] } = {};
    const regex = /(\d+)=([^,}]+)/g;
    let match;

    while ((match = regex.exec(str)) !== null) {
        const id = parseInt(match[1]);
        const categoria = match[2];

        if (result[categoria]) {
            if (!result[categoria].includes(id)) {
                result[categoria].push(id);
            }
        } else {
            result[categoria] = [id];
        }
    }

    for (const categoria in result) {
        if (result[categoria].length === 1) {
            delete result[categoria];
        }
    }


    return result;
}

export function clearDuplicatedChoices(
    duplicatedChoices: { [key: string]: number[] },
    choiceValue: string
) {
    let result = choiceValue;
    let processedCategories: { [key: string]: number } = {};


    for (const categoria in duplicatedChoices) {
        const ids = duplicatedChoices[categoria];
        const maxId = Math.max(...ids);

        //Reemplazar en la cadena de texto las categorias con valores menores al maximo
        for (const id of ids) {
            if (id !== maxId) {
                const regex = new RegExp(`\\b${id}=${categoria},?`, "g");
                result = result.replace(regex, "");
            }
        }


        
    }

    // Eliminar cualquier coma adicional dejada por el reemplazo
    result = fixChoiceString(result);

    // console.log("choice limpio: ", result);
    return result;
}

export function fixChoiceString(str: string): string {
    // Eliminar espacios en blanco al principio y al final del string
    str = str.trim();
    
    // Reemplazar comas innecesarias
    str = str.replace(/,{2,}/g, ','); // Reemplaza 2 o más comas consecutivas por una sola coma
    
    // Agregar categoría faltante si es necesario
    if (!str.startsWith('{')) {
        str = '{' + str;
    }
    if (!str.endsWith('}')) {
        str = str + '}';
    }
    
    // Eliminar cualquier coma adicional antes del cierre de llave
    str = str.replace(/,(?=})/g, '');
    
    return str;
}

export interface SerieZone {
    value: number,
    dashStyle?: string
}

export interface PointWithoutData {
    value: number | null,
    frame_id: number,
    timestamp: string
}

const hoursDifferenceDottedZone = 1;

export function isChartDeadZone(currentPoint: DataParent, nextPoint: DataParent):boolean {
    //comparo los 2 puntos consecutivos de la grafica
    //y me fijo si tienen una diferencia de al menos 1 hora
    let isDeadZone = false;

    if(currentPoint.timestamp && nextPoint.timestamp){
        let hoursDifferenceBetweenPoints = moment(currentPoint.timestamp).diff(moment(nextPoint.timestamp), diffOptions.hours);
        if(hoursDifferenceBetweenPoints >= hoursDifferenceDottedZone || hoursDifferenceBetweenPoints === -1){
            isDeadZone = true
        }
    }
    return isDeadZone
}
export function existPointsToChart(points:Array<[string, number]>): boolean{
    if(points.length == 0){
        return false
    }
    return  points.filter(point => point[1] !== null).length >= 2;
}


